module.exports = __webpack_public_path__ + "static/media/vedioSymbol.7d949c12.svg";